import { PutForecastForReceiptRequest } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';
import { ForecastForReceiptFormState } from '../domains/entities/ForecastForReceiptMenu';

/**
 * 受領用内示情報を変更するアダプタ
 */
export class UpdateForecastForReceiptAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param updateForecastForReceiptInfo - 更新する受領用内示情報
   */
  public static adaptForRequest(updateForecastForReceiptInfo: ForecastForReceiptFormState): PutForecastForReceiptRequest {
    return {
      updateForecastForReceiptInfo: {
        forecastForReceiptName: updateForecastForReceiptInfo.forecastForReceiptName,
        forecastForReceiptResponsibleUserIdList: updateForecastForReceiptInfo.forecastForReceiptResponsibleUserIdList,
        outputRange: updateForecastForReceiptInfo.outputRange,
      },
    };
  }
}
